import React from 'react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "../../../../components/ui/card";
import { Progress } from "../../../../components/ui/progress";
import { Skeleton } from "../../../../components/ui/skeleton";
import { ClusterMetrics } from '../utils/types';
import { MemoryUtilizationProps } from './types';

const MemoryUtilizationCard: React.FC<MemoryUtilizationProps> = ({
  clusterMetrics,
  isLoading,
  showGatewayNodes,
  showNormalNodes
}) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Cluster Memory Utilization</CardTitle>
        <CardDescription>
          Current memory usage across {showGatewayNodes && showNormalNodes 
            ? 'all nodes' 
            : showGatewayNodes 
            ? 'gateway nodes' 
            : 'normal nodes'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        ) : (
          <div className="space-y-2">
            <div className="flex justify-between text-sm mb-1">
              <span>Used: {clusterMetrics.memoryUtilization.usageFormatted}</span>
              <span>Total: {clusterMetrics.memoryUtilization.capacityFormatted}</span>
            </div>
            <Progress 
              value={clusterMetrics.memoryUtilization.percentage} 
              className="h-2"
            />
            <div className="text-sm text-right text-slate-500">
              {clusterMetrics.memoryUtilization.percentage.toFixed(1)}% utilized
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MemoryUtilizationCard; 